






























import { defineComponent, SetupContext, watch, onMounted } from '@vue/composition-api'
import BaseLayout from '@/components/_shared/BaseLayout.vue'
import MovieList from '@/components/MovieList/MovieList.vue'
import { UseFetchDataComposition } from '@/composition/UseFetchDataComposition'
import { UseAPIComposition } from '@/composition/UseAPIComposition'
import { UseSearchComposition } from '@/composition/UseSearchComposition'
import { UsePresenterComposition } from '@/composition/UsePresenterComposition'
import { UseSearchPresenter, SearchPresenter } from '@/containers/Search/UseSearchPresenter'

// ================================
// Component
// ================================
export default defineComponent({
  name: 'SearchContainer',
  components: { BaseLayout, MovieList },
  setup (props, context: SetupContext) {
    const query = context.root.$route.query.q
    const API = UseAPIComposition()
    const fetch = UseFetchDataComposition(context)
    const search = UseSearchComposition(context)
    const presenter = UsePresenterComposition()

    /**
     * Movie情報を取得するFetchの初期化処理
     */
    async function initFetch (query: string | (string | null)[]) {
      fetch.loading.value = true
      const fetchDatas = await fetch.fetchMovieSearchData(API.APIPathSearch(query))
      const searchPresenter = UseSearchPresenter(fetchDatas, fetch.responseDataCount(), query)
      await presenter.presenterDatas<SearchPresenter>(searchPresenter)
      fetch.loading.value = false
      window.scrollTo(0, 0)
    }

    // ================================
    // LifeCycle
    // ================================
    onMounted(async () => {
      await initFetch(query)
    })

    // ================================
    // Watch
    // ================================
    watch(() => context.root.$route, async (newRoute) => {
      await initFetch(newRoute.query.q)
    })

    return {
      API,
      fetch,
      search,
      presenter
    }
  }
})
